export const vs2ngaGlobalReleaseConstants = {
  VS2NGA_GLOBAL_RELEASE_LOADING: "VS2NGA_GLOBAL_RELEASE_LOADING",
  VS2NGA_GLOBAL_RELEASE_SUCCESS: "VS2NGA_GLOBAL_RELEASE_SUCCESS",
  VS2NGA_GLOBAL_RELEASE_FAILURE: "VS2NGA_GLOBAL_RELEASE_FAILURE",
};

export const addVs2ngaGlobalReleaseConstants = {
  ADD_VS2NGA_GLOBAL_RELEASE_LOADING: "ADD_VS2NGA_GLOBAL_RELEASE_LOADING",
  ADD_VS2NGA_GLOBAL_RELEASE_SUCCESS: "ADD_VS2NGA_GLOBAL_RELEASE_SUCCESS",
  ADD_VS2NGA_GLOBAL_RELEASE_FAILURE: "ADD_VS2NGA_GLOBAL_RELEASE_FAILURE",
};

export const editVs2ngaGlobalReleaseConstants = {
  EDIT_VS2NGA_GLOBAL_RELEASE_LOADING: "EDIT_VS2NGA_GLOBAL_RELEASE_LOADING",
  EDIT_VS2NGA_GLOBAL_RELEASE_SUCCESS: "EDIT_VS2NGA_GLOBAL_RELEASE_SUCCESS",
  EDIT_VS2NGA_GLOBAL_RELEASE_FAILURE: "EDIT_VS2NGA_GLOBAL_RELEASE_FAILURE",
};
